<template>
    <v-container fluid>
        <v-data-table
            :headers="headers"
            :items="itemsFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
            :height="$vuetify.breakpoint.mdAndDown ? '75vh' : '66vh'"
            fixed-header
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <v-col cols="12" class="d-flex mb-n3">
                        <h1 class="mr-4">Profiles</h1>
                        <v-btn
                            rounded
                            color="primary"
                            @click="openCreateItem"
                            class="mx-2"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                            {{ $vuetify.breakpoint.smAndDown ? '' : 'NEW' }}
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.model`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByModel"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <template v-slot:[`header.part`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByPart"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <template v-slot:[`header.description`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByDescription"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <template v-slot:[`header.reference`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByReference"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.k_m`]="{ item }">
                <p class="py-0 my-0">{{ formatNumber(item.k_m) }}</p>
            </template>
            <template v-slot:[`item.length`]="{ item }">
                <p class="py-0 my-0">{{ formatNumber(item.length) }}</p>
            </template>
            <template v-slot:[`item.totalWeight`]="{ item }">
                <p class="py-0 my-0">{{ formatNumber(item.totalWeight) }}</p>
            </template>
            <template v-slot:[`item.area`]="{ item }">
                <p class="py-0 my-0">{{ formatNumber(item.area) }}</p>
            </template>
            <template v-slot:[`item.totalArea`]="{ item }">
                <p class="py-0 my-0">{{ formatNumber(item.totalArea) }}</p>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="openEditItem(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <!-- <v-btn small icon @click="openDeleteItem(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn> -->
                </div>
            </template>
        </v-data-table>
        <!--FORM-->
        <v-dialog
            v-model="openItemForm"
            :retain-focus="false"
            persistent
            width="600px"
        >
            <ProfileForm
                v-if="openItemForm"
                :createForm="createForm"
                :item="selectedItem"
                :originalItem="originalItem"
                :setting="setting"
                @addItem="addItem"
                @replaceItem="replaceItem"
                @close="closeEditItem"
            />
        </v-dialog>
        <!--Delete-->
        <v-dialog
            v-model="openDeleteWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="openDeleteWarning">
                <v-card-title class="text-h5">Delete Item</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this profile?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeDeleteItem">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="deleteItem"
                        text
                        color="error"
                        :loading="loading"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import API from '@/services/api'

export default {
    name: 'Profiles',
    props: {
        setting: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        ProfileForm: () =>
            import('@/components/Settings/Clients/ProfileForm.vue'),
    },
    data: () => ({
        loading: false,
        items: [],
        selectedItem: {},
        originalItem: {},
        createForm: true,
        openItemForm: false,
        openDeleteWarning: false,
        headers: [
            {
                text: 'MODEL',
                value: 'model',
                sortable: false,
            },
            {
                text: 'PART',
                value: 'part',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                sortable: false,
            },
            {
                text: 'REFERENCE',
                value: 'reference',
                sortable: false,
            },
            {
                text: '(K/M)',
                value: 'k_m',
                sortable: false,
                align: 'center',
            },
            {
                text: 'LENGTH (M)',
                value: 'length',
                sortable: false,
                align: 'center',
            },
            {
                text: 'TOTAL WEIGHT (KG)',
                value: 'totalWeight',
                sortable: false,
                align: 'center',
            },
            {
                text: 'PERIMETER (M)',
                value: 'perimeter',
                sortable: false,
                align: 'center',
            },
            {
                text: 'TOTAL AREA (M2)',
                value: 'totalArea',
                sortable: false,
                align: 'center',
            },
            {
                text: 'ACTION',
                value: 'action',
                sortable: false,
                align: 'center',
            },
        ],
        searchByModel: '',
        searchByPart: '',
        searchByDescription: '',
        searchByReference: '',
    }),
    async mounted() {
        try {
            this.loading = true
            this.items = await API.getAllProfiles(this.setting.id)
        } catch (error) {
            this.setErrorItems({
                name: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    computed: {
        itemsFiltered() {
            const conditions = []
            if (this.searchByModel) {
                conditions.push(this.filterByModel)
            }
            if (this.searchByPart) {
                conditions.push(this.filterByPart)
            }
            if (this.searchByDescription) {
                conditions.push(this.filterByDescription)
            }
            if (this.searchByReference) {
                conditions.push(this.filterByReference)
            }
            if (conditions.length > 0) {
                return this.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }
            return this.items
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE', {
                maximumFractionDigits: 4,
            }).format(number || 0)
        },
        filterByModel(item) {
            return item.model
                .toLowerCase()
                .includes(this.searchByModel.toLowerCase())
        },
        filterByPart(item) {
            return item.part
                .toLowerCase()
                .includes(this.searchByPart.toLowerCase())
        },
        filterByDescription(item) {
            return item.description
                .toLowerCase()
                .includes(this.searchByDescription.toLowerCase())
        },
        filterByReference(item) {
            return item.reference
                .toLowerCase()
                .includes(this.searchByReference.toLowerCase())
        },
        replaceItem(itemToUpdate) {
            const index = this.items.findIndex(
                item => item.id == itemToUpdate.id
            )
            if (index >= 0) {
                this.items.splice(index, 1, {
                    ...this.items[index],
                    ...itemToUpdate,
                })
            }
        },
        addItem(item) {
            this.items.push(item)
            this.searchByName = ''
        },
        removeItem() {
            const index = this.items.findIndex(
                item => item.id == this.selectedItem.id
            )
            if (index >= 0) {
                this.items.splice(index, 1)
            }
        },
        async deleteItem() {
            try {
                this.loading = true
                await API.deleteProfile({
                    settingId: this.setting.id,
                    id: this.selectedItem.id,
                })
                this.removeItem()
                this.closeDeleteItem()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeDeleteItem() {
            this.selectedItem = {}
            this.openDeleteWarning = false
        },
        openDeleteItem(item) {
            this.selectedItem = _.cloneDeep(item)
            this.openDeleteWarning = true
        },
        closeEditItem() {
            this.createForm = true
            this.selectedItem = {}
            this.originalItem = {}
            this.openItemForm = false
        },
        openEditItem(item) {
            this.createForm = false
            this.selectedItem = _.cloneDeep(item)
            this.originalItem = _.cloneDeep(item)
            this.openItemForm = true
        },
        openCreateItem() {
            this.createForm = true
            this.openItemForm = true
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
    position: sticky;
    z-index: 2;
}
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
</style>
